module.exports = __webpack_public_path__ + "static/media/27.a1cb1b07.png";